module.exports = __webpack_public_path__ + "img/mem2.12a6102c.png";